var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAgSolution = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94879 7.04352C5.02946 7.04352 3.4744 5.48772 3.4744 3.56912C3.4744 1.65052 5.03019 0.0947266 6.94879 0.0947266C8.86739 0.0947266 10.4232 1.65052 10.4232 3.56912C10.4232 5.48772 8.86739 7.04352 6.94879 7.04352ZM13.2971 8.56787C12.7346 7.41144 11.2512 7.05742 10.2316 7.84226C9.3231 8.54153 8.18422 8.95773 6.94879 8.95773C5.71337 8.95773 4.62572 8.56055 3.72749 7.88908C2.69834 7.11959 1.21861 7.47508 0.669289 8.63589C0.239927 9.54289 0 10.5567 0 11.6261C0 11.6283 0 11.6312 0 11.6334C0 12.1052 0.172628 12.5638 0.481301 12.9207C2.06051 14.7486 4.39458 15.9058 7.00001 15.9058C9.60544 15.9058 11.9395 14.7486 13.5187 12.9207C13.8274 12.5638 13.9993 12.1052 14 11.6334C14 11.6312 14 11.6283 14 11.6261C14 10.5296 13.7469 9.49169 13.2971 8.56787Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAgSolution);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_ag_solution.e824f61adc8141acfed3cbff32ace8de.svg";